export default __webpack_public_path__ + "static/media/bannerMintingBg.f933e7e7.png";